import { c as _c } from "react/compiler-runtime";
import { Button } from '@/components/Atoms/Button/Button';
import { PrintAction } from '@/components/Atoms/PrintAction/PrintAction';
import Email from '@/components/Icons/Email';
import { useDialog } from '@/components/Molecules/Dialog/Dialog';
import { SaveButton } from '@/components/Molecules/SaveButton/SaveButton';
import { EmailModal } from '@/components/Organisms/EmailModal/EmailModal';
import useTranslation from '@/hooks/useTranslation';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction, TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import type { ReactNode } from 'react';
import { Fragment } from 'react';
import type { INewsStory } from './NewsRsfPage';
export const useNewsActions = news => {
  const $ = _c(31);
  const emailDialog = useDialog();
  const {
    t
  } = useTranslation("news");
  const t0 = `News: ${news.id}`;
  let t1;
  if ($[0] !== news.id || $[1] !== news.title || $[2] !== news.type || $[3] !== t0) {
    t1 = <SaveButton key="save" id={news.id} type={news.type} itemName={news.title} analyticsBaseId={t0} />;
    $[0] = news.id;
    $[1] = news.title;
    $[2] = news.type;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <PrintAction key="print" />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let actions;
  if ($[6] !== emailDialog || $[7] !== news.canShare || $[8] !== news.id || $[9] !== t || $[10] !== t1) {
    actions = [t1, t2];
    if (news.canShare) {
      let t3;
      if ($[12] !== emailDialog) {
        t3 = () => emailDialog.open();
        $[12] = emailDialog;
        $[13] = t3;
      } else {
        t3 = $[13];
      }
      let t4;
      if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <Email />;
        $[14] = t4;
      } else {
        t4 = $[14];
      }
      const t5 = `News: ${news.id}`;
      let t6;
      if ($[15] !== t5) {
        t6 = buildTrackingObject(TrackingAction.GenerateLink, TrackingCategory.Email, t5);
        $[15] = t5;
        $[16] = t6;
      } else {
        t6 = $[16];
      }
      let t7;
      if ($[17] !== t) {
        t7 = t("common:Actions.send_email");
        $[17] = t;
        $[18] = t7;
      } else {
        t7 = $[18];
      }
      let t8;
      if ($[19] !== t3 || $[20] !== t6 || $[21] !== t7) {
        t8 = <Button kind="tertiary" onClick={t3} icon={t4} data-analytics-tracking={t6}>{t7}</Button>;
        $[19] = t3;
        $[20] = t6;
        $[21] = t7;
        $[22] = t8;
      } else {
        t8 = $[22];
      }
      const t9 = `/news_stories/${news.id}/send_email`;
      let t10;
      if ($[23] !== t9) {
        t10 = {
          apiUrl: t9
        };
        $[23] = t9;
        $[24] = t10;
      } else {
        t10 = $[24];
      }
      let t11;
      if ($[25] !== emailDialog || $[26] !== t10) {
        t11 = <EmailModal dialog={emailDialog} form={t10} />;
        $[25] = emailDialog;
        $[26] = t10;
        $[27] = t11;
      } else {
        t11 = $[27];
      }
      let t12;
      if ($[28] !== t11 || $[29] !== t8) {
        t12 = <Fragment key="email">{t8}{t11}</Fragment>;
        $[28] = t11;
        $[29] = t8;
        $[30] = t12;
      } else {
        t12 = $[30];
      }
      actions.push(t12);
    }
    $[6] = emailDialog;
    $[7] = news.canShare;
    $[8] = news.id;
    $[9] = t;
    $[10] = t1;
    $[11] = actions;
  } else {
    actions = $[11];
  }
  return actions;
};